// ImprovedSpinnerOverlay.jsx
import React from 'react';
import './ImprovedSpinnerOverlay.css';

const SpinnerOverlay = ({ 
  text = '', 
  variant = 'default', 
  blur = true,
  dark = false 
}) => {
  const overlayClass = `spinner-overlay ${blur ? 'backdrop-blur' : ''} ${dark ? 'dark' : ''}`;
  const spinnerClass = `spinner spinner-${variant}`;
  
  return (
    <div className={overlayClass}>
      <div className="spinner-container">
        <div className={spinnerClass}>
          <div className="spinner-track"></div>
          <div className="spinner-fill"></div>
          <div className="spinner-center"></div>
        </div>
        {text && (
          <p className="spinner-text">{text}</p>
        )}
      </div>
    </div>
  );
};

export default SpinnerOverlay;

// Usage examples:
// <SpinnerOverlay />
// <SpinnerOverlay text="Loading..." />
// <SpinnerOverlay variant="gradient" text="Please wait" />
// <SpinnerOverlay variant="pulse" blur={false} />
// <SpinnerOverlay variant="glow" dark={true} />